// Why a query failed, for RUM. Names and codes only: messages can echo request
// data, so they stay out.
export type RequestFailureContext = {
  failureType: 'network' | 'graphql' | 'unknown';
  statusCode?: number;
  errorName?: string;
  graphqlErrorCode?: string;
};

export const requestFailureContext = (error: any): RequestFailureContext => {
  const { networkError, graphQLErrors } = error ?? {};

  if (networkError) {
    return {
      failureType: 'network',
      statusCode: networkError.statusCode,
      errorName: networkError.name,
    };
  }

  if (graphQLErrors?.length) {
    return {
      failureType: 'graphql',
      errorName: error.name,
      graphqlErrorCode: graphQLErrors[0].extensions?.code,
    };
  }

  return { failureType: 'unknown', errorName: error?.name };
};
